import React, { useCallback, useEffect } from 'react'
import { TaxSection } from '../../../TaxSection'
import { useAnalysisMode } from '../../contexts/AnalysisModeContext'
import { useAnalysisServices } from '../../contexts/AnalysisServicesContext'
import { useAnalysisMapSectionData } from '../../contexts/MapSectionDataContext'

export const TaxTab: React.FC = () => {
  const { entity, userId, readOnly } = useAnalysisMode()
  const { getSectionData, updateSectionData, onDataFetched } =
    useAnalysisServices()
  const { setActiveSection } = useAnalysisMapSectionData()

  useEffect(() => {
    setActiveSection('taxes')
  }, [setActiveSection])

  const handleDataFetched = useCallback(
    (data: any) => {
      onDataFetched('taxes', data)
    },
    [onDataFetched]
  )

  const handleUpdateTaxData = useCallback(
    async (ent: any, uid: string) => {
      const result = await updateSectionData('taxes', ent, uid)
      handleDataFetched(result)
      return result
    },
    [updateSectionData, handleDataFetched]
  )

  if (!entity || !userId) return null

  return (
    <TaxSection
      entity={{
        id: entity.id || entity.land_id || '',
        geo_center: entity.geo_center,
        npa:
          entity.address_postal_code_name || entity.address_postal_code || '',
        municipality_name: entity.municipality_name,
        canton_name: entity.canton_name,
      }}
      userId={userId}
      getTaxData={() => getSectionData('taxes')}
      onDataFetched={handleDataFetched}
      updateTaxData={handleUpdateTaxData}
      readOnly={readOnly}
    />
  )
}
